<template>
  <div class="upload videouploadLoader px-8" style="width: 100% !important">
    <div v-if="localModel.selectedFile">
      <div
        class="
          file-list
          flex flex-row
          rounded-lg
          x-overflow-scroll
          border-grey-200 border
          items-center
          justify-between
          px-6
          h-auto
          youtube-video-name-container
        "
        style="min-height: 4rem"
      >
        <div class="flex text-deep-dark font-semibold flex-col text-left mr-2">
          {{
            $t('frontend_groovevideo_uploaded_video', {
              fileName: localModel.selectedFile.name,
            })
          }}
        </div>
        <delete-icon
          v-if="showDelete"
          class="cursor-pointer text-grey-500"
          @click="removeFile()"
        />
      </div>
    </div>
    <vue-dropzone
      v-show="!localModel.selectedFile"
      id="customdropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      :use-custom-slot="true"
      :awss3="awss3"
      @vdropzone-success="uploadSuccess"
      @vdropzone-s3-upload-error="uploadError"
      @vdropzone-upload-progress="uploadProgress"
      @vdropzone-total-upload-progress="totalProgress"
      @vdropzone-file-added="fileAdded"
    >
      <div class="dropzone-custom-content">
        <div
          class="
            border-dashed
            rounded-lg
            bgcolor
            border
            flex flex-col
            h-60
            justify-center
            items-center
            px-4
          "
        >
          <div class="text-xs subtitle mb-4">
            <div class="mb-3">
              {{ $t('frontend_groovevideo_videos_fileupload_drag_drop') }}
            </div>
            {{ $t('frontend_groovevideo_videos_fileupload_or') }}
          </div>
          <div
            class="w-full flex flex-row flex-nowrap items-center justify-center"
          >
            <gd-button primary class="px-4 w-auto">
              {{ $t('frontend_groovevideo_upload_choose_file') }}
            </gd-button>
          </div>
        </div>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
import Video from '@/models/Video';
import DeleteIcon from '@/assets/images/icons/delete-icon.svg';

export default {
  props: {
    showDelete: {
      default() {
        return true;
      },
    },
    uploadModel: {
      required,
    },
    videoModel: {},
    validateForm: {},
    closeModal: {},
  },
  components: {
    vueDropzone: vue2Dropzone,
    DeleteIcon,
  },
  data() {
    return {
      localModel: this.uploadModel,
      maxSize: 256000,
      newActivity: {
        status: '',
        msg: '',
      },
      nextButtonDisabled: true,
      dropzoneOptions: {
        acceptedFiles: '.mp4,.webm,.flv',
        url: `${window.config.apiUrl}/upload`,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: this.maxSize,
        autoProcessQueue: false,
        autoQueue: true,
      },
      awss3: {
        signingURL: `${window.config.apiUrl}/get-groove-signing-url`,
        headers: {
          email: this.$store.state.user.email,
          apiKey: this.$store.state.user.api_key,
        },
        params: {
          youtubeUpload: true,
        },
        sendFileToServer: false,
        withCredentials: false,
      },
    };
  },
  validations: {
    localModel: {
      selectedFile: {
        required,
      },
    },
  },
  methods: {
    validate() {
      // return true;
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    removeFile() {
      this.$refs.myVueDropzone.removeFile(this.localModel.selectedFile);
      this.localModel.selectedFile = null;
    },

    uploadProgress(file, progress, bytesSent) {
      this.$emit('uploadProgress', file, progress, bytesSent, true);
    },

    totalProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      console.log('total', totaluploadprogress, totalBytes, totalBytesSent);
    },

    startUpload() {
      const self = this;
      // Check queued file
      if (self.$refs.myVueDropzone.getQueuedFiles().length) {
        const element = self.$el.querySelector('#customdropzone');
        if (element.classList.contains('dz-started')) {
          self.$emit('updateDisplayUploadbox', true);
        }
        // Initiate file upload
        self.$refs.myVueDropzone.processQueue();
      }
    },
    fileAdded(file) {
      const fileSize = (file.size / (1000 * 1000)).toFixed(1);

      // Validate
      const isValid = this.validateForm();

      // Max File Size Check
      if (fileSize > this.maxSize) {
        // Remove file in case greater than allowed file size
        this.$refs.myVueDropzone.removeFile(file);

        // Show error message
        Swal.fire(
          'Uplaod Error',
          `Files larger than ${this.maxSize}MB are not allowed.`,
          'error'
        );
      } else if (!isValid) {
        // Close modal in case invalid fields
        this.closeModal();
      } else {
        setTimeout(async () => {
          [this.localModel.selectedFile] =
            this.$refs.myVueDropzone.getQueuedFiles();
          // this.localModel.title = this.localModel.selectedFile.name
          //   .split('.')
          //   .slice(0, -1)
          //   .join('.');
        }, 300);
      }
    },
    async uploadSuccess(file, response) {
      if (response && response.Location) {
        let s3URL = decodeURIComponent(response.Location);
        // Append schema if not present
        s3URL = this.includeHttps(s3URL);
        await this.s3UploadSuccess(s3URL);
      }
    },

    async s3UploadSuccess(fileLink) {
      this.uploadModel.fileLink = fileLink;
      const self = this;
      await axios.post('youtube-upload', this.uploadModel).then((response) => {
        if (response.data.status == 'processing') {
          self.$refs.myVueDropzone.disable();
          self.newActivity = 'encoding';
          self.nextButtonDisabled = false;
          self.addVideo();
        } else {
          this.uploadError();
        }
      });
    },
    async uploadError(uploadFailed = false) {
      const self = this;
      if (!uploadFailed && !self.$route.params.id) {
        const vid = await Video.$find(self.videoModel.id);
        self.video = {
          name: vid.name,
          category_id: vid.category_id,
        };
        await vid.delete();
      }
      self.hideLoader();
      self.newActivity = 'failed';
      await Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'Cannot upload video. Please try again',
        reverseButtons: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
      });
      self.$emit('updateDisplayUploadbox', false);
      self.$refs.myVueDropzone.removeAllFiles();
      self.$refs.myVueDropzone.enable();
    },

    addVideo() {
      // Redirect only when button is active
      if (!this.nextButtonDisabled) {
        this.$router.push({
          name: 'AddNewVideo',
          params: {
            id: this.uploadModel.video_id,
            activityCreated: this.newActivity,
          },
        });
      }
    },

    includeHttps(url) {
      return url.replace(
        /^(?:(.*:)?\/\/)?(.*)/i,
        (match, schemma, nonSchemmaUrl) =>
          schemma ? match : `https://${nonSchemmaUrl}`
      );
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
  },
};
</script>
<style scoped>
.youtube-video-name-container {
  background-color: #f4f4fc;
}
</style>